// Validación del correo del tutor para el navegador.
//
// Es una COPIA deliberada de `supabase/functions/consentimiento-otp/validacion.ts`:
// CRA no puede importar fuera de `src/`, y la Edge Function corre en Deno. Para que
// las dos no se separen con el tiempo, `__tests__/correoValido.test.js` corre ambas
// contra la misma tabla de casos y falla si dejan de coincidir.
//
// El servidor manda: esto solo sirve para avisarle al tutor antes de que apriete el
// botón, con el campo todavía enfrente.

const MAX_CORREO = 254
const MAX_LOCAL = 64
const MAX_DOMINIO = 255

const LOCAL_OK = /^[a-z0-9!#$%&'*+/=?^_`{|}~.-]+$/
const ETIQUETA_OK = /^[a-z0-9]([a-z0-9-]*[a-z0-9])?$/
const TLD_OK = /^([a-z]{2,}|xn--[a-z0-9-]+)$/

export const correoValido = (crudo) => {
  const correo = String(crudo || '').trim().toLowerCase()
  if (!correo || correo.length > MAX_CORREO) return false
  if (correo.includes('..')) return false

  const partes = correo.split('@')
  if (partes.length !== 2) return false
  const [local, dominio] = partes

  if (!local || local.length > MAX_LOCAL) return false
  if (local.startsWith('.') || local.endsWith('.')) return false
  if (!LOCAL_OK.test(local)) return false

  if (!dominio || dominio.length > MAX_DOMINIO) return false
  const etiquetas = dominio.split('.')
  if (etiquetas.length < 2) return false
  if (etiquetas.some((e) => e.length === 0 || e.length > 63 || !ETIQUETA_OK.test(e))) return false
  if (!TLD_OK.test(etiquetas[etiquetas.length - 1])) return false

  return true
}
